import icon from "../../assets/door.svg";
import type { Property } from "../../types";

export const includedReaders: Property = {
  id: "includedReaders",
  title: "includedReaders.title",
  icon,
};
